module.exports = __webpack_public_path__ + "img/banner.900a8cc4.png";